module.exports = __webpack_public_path__ + "static/img/qucode.3811940d.jpg";